import {
  List,
  ListItem,
  ListItemText,
  Box,
  Typography,
  ListItemIcon
} from '@mui/material'
import { useFormStore } from '../../functions/formStore'
import { useAuth0 } from '@auth0/auth0-react'
import { Check } from "@mui/icons-material"
import { join } from 'lodash/fp'


const Confirm = (): JSX.Element => {
  const { data } = useFormStore()
  const { user } = useAuth0()

  return (
    <Box>
      <Box display="grid" justifyContent={"center"} marginY={5}>
        <Typography variant="h6" borderBottom={2} borderColor={"GrayText"} color="gray">ご回答内容のご確認</Typography>
      </Box>
      <List>
        <Box display={"flex"} flexDirection={"column"} justifyContent={"center"} >
          <ListItem>
            <ListItemIcon><Check /></ListItemIcon>
            <ListItemText primary="おなまえ" secondary={data.No1} />
          </ListItem>
          <ListItem>
            <ListItemIcon><Check /></ListItemIcon>
            <ListItemText primary="性別" secondary={data.No2} />
          </ListItem>
          <ListItem>
            <ListItemIcon><Check /></ListItemIcon>
            <ListItemText primary="このサービスをどこで知りましたか？" secondary={data.No3} />
          </ListItem>
          <ListItem>
            <ListItemIcon><Check /></ListItemIcon>
            <ListItemText primary="利用規約" secondary={join("\n")(data.No4)} />
          </ListItem>
        </Box>
      </List>
    </Box>
  )
}

export default Confirm